(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-video-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
 const button = event.target.closest('[data-gallery-direction]');
 if (!button) return;
 const gallery = button.closest('[data-customer-gallery]');
 const track = gallery.querySelector('[data-gallery-track]');
 const card = track.querySelector('.customer-video-card');
 if (!card) return;
 const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
 track.scrollBy({left: Number(button.dataset.galleryDirection) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
  } catch(e) { console.error(e); }
})();

})();
